export const TRAILER_DETAIL_INITIAL_STATE = {
    trailerNumber: '',
    trailerSize: '',
    driverName: '',
    currentDriverId: 0,
    companyPercent: 0,
    rentPercent: 0,
    isDeleted: false,
};
